import styled from 'styled-components'

const TextContent = styled.div`
  margin-top: 20px;
  font-family: ${({ theme }) => theme.fonts.sourceSansPro};
  font-weight: 400;
  font-size: 18px;
  line-height: 1.22;
`

export default TextContent
